import * as React from "react";
const { useState, useEffect, useRef } = React;
const CountDown = (props) => {
    const { timeStamp, activity } = props;
    const intervalRef = useRef(null);

    const now = Date.now();
    const end = timeStamp; 

    const [leftTime, setLeftTime] = useState(0);
    const [h, setHours] = useState("00");
    const [m, setMinutes] = useState("00");
    const [s, setSeconds] = useState("00");
    const [isActivityClosed, setIsActivityClosed] = useState(false);

    const _format = (count) => {
        if (count < 10) {
            return `0${count}`;
        }

        return count;
    }

    useEffect(() => {
        setIsActivityClosed((activity?.status?.toLowerCase() === 'closed') || (activity?.activityStatus?.toLowerCase() === 'closed'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activity, activity?.status, activity?.activityStatus]);

    useEffect(() => {
        setLeftTime((end - now) / 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [timeStamp]);


    useEffect(() => {
        setLeftTime((end - now) / 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [timeStamp]);

    useEffect(() => {
        if (isNaN(leftTime)) return;
        if (leftTime > 0 && (activity?.status?.toLowerCase() !== 'closed') && (activity?.activityStatus?.toLowerCase() !== 'closed')) {
            intervalRef.current = setInterval(() => {
                let newLeftTime = (timeStamp - Date.now()) / 1000;
                setLeftTime(() => newLeftTime);

                let hours = _format(parseInt(newLeftTime / 3600));
                let minutes = _format(parseInt((newLeftTime % 3600) / 60));
                let seconds = _format(parseInt((newLeftTime % 3600) % 60));
                setHours(() => hours)
                setMinutes(() => minutes)
                setSeconds(() => seconds)

            }, 1000);
        } else {
            setLeftTime(0)
            setHours('00')
            setMinutes('00')
            setSeconds('00')
            clearInterval(intervalRef.current);
        }
        return () => clearInterval(intervalRef.current); 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [leftTime]);
    return (
        <>
            <span className='f-size-14 f-weight-700 line-height-18' style={{ color: isActivityClosed ? '#910818' : '#203645' }}>{activity?.activityStatus?.toLowerCase() === 'new' ? 'Not Started' : `${h}:${m}:${s}`}</span>
        </>
    )

}

export default CountDown;
